var Handlebars = require("../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "		<h1 class=\"link-list-module__title\">"
    + ((stack1 = lookupProperty(helpers,"block").call(depth0 != null ? depth0 : (container.nullContext || {}),"title",{"name":"block","hash":{},"data":data,"loc":{"start":{"line":4,"column":38},"end":{"line":4,"column":57}}})) != null ? stack1 : "")
    + "</h1>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "		<div class=\"link-list-module__text\">\n			"
    + ((stack1 = lookupProperty(helpers,"block").call(depth0 != null ? depth0 : (container.nullContext || {}),"text",{"name":"block","hash":{},"data":data,"loc":{"start":{"line":9,"column":3},"end":{"line":9,"column":21}}})) != null ? stack1 : "")
    + "\n		</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section class=\"link-list-module__column\">\n	<header class=\"link-list-module__copy\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(helpers,"content").call(alias1,"title",{"name":"content","hash":{},"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":3,"column":25}}}),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":2},"end":{"line":5,"column":9}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(helpers,"content").call(alias1,"text",{"name":"content","hash":{},"data":data,"loc":{"start":{"line":7,"column":8},"end":{"line":7,"column":24}}}),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":2},"end":{"line":11,"column":9}}})) != null ? stack1 : "")
    + "\n		"
    + ((stack1 = lookupProperty(helpers,"block").call(alias1,"cta",{"name":"block","hash":{},"data":data,"loc":{"start":{"line":13,"column":2},"end":{"line":13,"column":19}}})) != null ? stack1 : "")
    + "\n	</header>\n\n	<div class=\"link-list-module__links\">\n		"
    + ((stack1 = lookupProperty(helpers,"block").call(alias1,"links",{"name":"block","hash":{},"data":data,"loc":{"start":{"line":17,"column":2},"end":{"line":17,"column":21}}})) != null ? stack1 : "")
    + "\n	</div>\n</section>\n";
},"useData":true});